import React, {useState} from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { GEO_API_URL, geoApiOptions } from "../../../api/api";
import {Theme} from "../../../context/ThemeContext";
import {useTheme} from "../../../hooks/useTheme";


interface City {
    latitude: number;
    longitude: number;
    name: string;
    countryCode: string;
}

export interface HeaderSearchProps {
    onSearchChange: (searchData: SearchData | null) => void;
}

export interface SearchData {
    value: string
    label: string

}

export const HeaderSearch = ({ onSearchChange }: HeaderSearchProps) => {

    const [search, setSearch] = useState<SearchData | null>(null);

    const theme = useTheme();
    const colourStyles = {
        control: (styles: any) => ({
            ...styles,
            backgroundColor:
                theme.theme === Theme.DARK ? '#4F4F4F' : 'rgba(71, 147, 255, 0.2)',
            width: '146px',
            height: '28px',
            fontSize: '13px',
            border: 'none',
            borderRadius: '8px',
            zIndex: 100,
        }),
        singleValue: (styles: any) => ({
            ...styles,
            color: theme.theme === Theme.DARK ? '#fff' : '#000',
        }),
        placeholder: (styles: any) => ({
            ...styles,
            fontSize: '10px',
        }),
    };

    const loadOptions = (inputValue: string) => {
        return fetch(
            `${GEO_API_URL}/cities?minPopulation=300000&namePrefix=${inputValue}`,
            geoApiOptions
        )
            .then((response) => response.json())
            .then((response) => {
                return {
                    options: response.data.map((city: City) => {
                        return {
                            value: `${city.latitude} ${city.longitude}`,
                            label: `${city.name}, ${city.countryCode}`,
                        };
                    }),
                };
            })
    }

    const handleOnChange = (searchData: SearchData | null) => {
        setSearch(searchData);
        onSearchChange(searchData);
    };

    return (
        <AsyncPaginate
            styles={colourStyles}
            placeholder="Search your city"
            debounceTimeout={800}
            value={search}
            onChange={handleOnChange}
            loadOptions={loadOptions}
        />
    );
};
